import {
  GET_LIST_DUNOGIAONHANVIEN,
  GET_LIST_DUNOGIAONHANVIEN_SUCCESS,
  GET_LIST_DUNOGIAONHANVIEN_FAILURE,
  UPDATE_SEARCHTDATA_DUNOGIAONHANVIEN,
} from "./actionTypes";

export const getListDuNoGiaoNhanVien = (dataSearch) => ({
  type: GET_LIST_DUNOGIAONHANVIEN,
  dataSearch,
});
export const getListDuNoGiaoNhanVienSuccess = (data) => ({
  type: GET_LIST_DUNOGIAONHANVIEN_SUCCESS,
  payload: data,
});
export const getListDuNoGiaoNhanVienFailure = (dataSearch) => ({
  type: GET_LIST_DUNOGIAONHANVIEN_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_DUNOGIAONHANVIEN,
  payload: data,
});
